"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNLOCK_DESIGN_BOM_EVENTS = void 0;
var UNLOCK_DESIGN_BOM_EVENTS;
(function (UNLOCK_DESIGN_BOM_EVENTS) {
    UNLOCK_DESIGN_BOM_EVENTS["UNLOCK_DESIGN_BOM"] = "UNLOCK_DESIGN_BOM";
    UNLOCK_DESIGN_BOM_EVENTS["UNLOCK_DESIGN_BOM_SUCCESS"] = "UNLOCK_DESIGN_BOM_SUCCESS";
})(UNLOCK_DESIGN_BOM_EVENTS || (exports.UNLOCK_DESIGN_BOM_EVENTS = UNLOCK_DESIGN_BOM_EVENTS = {}));
